export function normalizeDocumentStatus(status?: string | null): string {
  return String(status ?? '')
    .trim()
    .toUpperCase()
    .replace(/-/g, '_');
}

export function isDraftDocumentStatus(status?: string | null): boolean {
  return normalizeDocumentStatus(status) === 'DRAFT';
}

export function isCancelledDocumentStatus(statusNorm: string): boolean {
  return statusNorm.includes('CANCEL');
}

export function documentStatusBadgeClass(statusNorm: string): string {
  if (!statusNorm) return 'bg-slate-50 text-slate-600 border-slate-200';
  if (isCancelledDocumentStatus(statusNorm)) {
    return 'bg-red-50 text-red-800 border-red-200';
  }
  if (statusNorm === 'E_INVOICED') {
    return 'bg-emerald-50 text-emerald-800 border-emerald-200';
  }
  if (statusNorm === 'DRAFT') {
    return 'bg-amber-50 text-amber-900 border-amber-200';
  }
  return 'bg-slate-50 text-slate-800 border-slate-200';
}

export function documentStatusDisplayLabel(status?: string | null): string {
  const norm = normalizeDocumentStatus(status);
  if (!norm) return '—';
  if (norm === 'E_INVOICED') return 'E-Invoiced';
  if (norm === 'DRAFT') return 'Draft';
  return norm.replace(/_/g, ' ');
}
